<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createProductoPaginaIdroop"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        key="modal section"
        class="m-the-modal-section-height-auto"
      >
        <blockquote class="quote quote-products-primary quote-first">
          <p>
            {{ $t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.quote') }}
          </p>
        </blockquote>
        <AtomInputPrimary
          v-model="pagina.nombre"
          :inputError="$v.pagina.nombre.$error"
          :label="$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.inputs.nombre.label')"
          :message="$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.inputs.nombre.message')"
          :messageError="messageErrorNombre"
          name="nombre"
          :placeholder="$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.inputs.nombre.placeholder')"
          type="text"
          @blur="$v.pagina.nombre.$touch()"
        />
        <AtomInputPrimary
          v-model="pagina.url"
          :inputError="$v.pagina.url.$error"
          :label="$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.inputs.url.label')"
          :messageError="messageErrorUrl"
          name="url"
          :placeholder="$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.inputs.url.placeholder')"
          type="text"
          @blur="$v.pagina.url.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required, url } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionProductPagesOfGratefulnessModalCreateExternalSite',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductPagesOfGratefulnessModalCreateExternalSite.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      },

      pagina: {
        externo: 1,
        nombre: '',
        producto: this.$route.params.id,
        tipo: 1,
        url: ''
      }
    }
  },

  validations: {
    pagina: {
      nombre: {
        maxLength: maxLength(60),
        minLength: minLength(1),
        required
      },

      url: {
        required,
        url
      }
    }
  },

  computed: {
    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionProductPagesOfGratefulnessModalCreateExternalSite', this.$v.pagina.nombre, 'nombre')
    },

    messageErrorUrl () {
      return this.$validation.getValidationMessage('mEditionProductPagesOfGratefulnessModalCreateExternalSite', this.$v.pagina.url, 'url')
    }
  },

  methods: {
    createProductoPaginaIdroop () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('producto', 'createProductoPaginaIdroop', this.pagina)
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionProductPagesOfGratefulnessModalCreateExternalSite', 'createProductoPaginaIdroop', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductPagesOfGratefulnessModalCreateExternalSite', 'createProductoPaginaIdroop', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
